var map = {
	"./customer-bg.webp": 1489,
	"./customer-img.webp": 1490,
	"./dice-img.webp": 1491,
	"./games-img.webp": 1492,
	"./lc-img.webp": 1493,
	"./lottery-img.webp": 1494,
	"./mission-bg.webp": 1495,
	"./mission-img-2.webp": 1496,
	"./mission-img.webp": 1497,
	"./mission-main-bg.webp": 1498,
	"./mobile-bg.webp": 1499,
	"./p2p-img.webp": 1500,
	"./product-bg.webp": 1501,
	"./product-main-bg.webp": 1502,
	"./sb-provider.webp": 1503,
	"./sbo-provider.webp": 1504,
	"./side-bar-bg.webp": 1505,
	"./slot-img.webp": 1506,
	"./spade-img.webp": 1507,
	"./sport-img.webp": 1508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 205;